import { ListLayoutLauncher } from "@mcleod/components/src/page/ListLayoutLauncher";
import { AutogenLayoutDriverEquipStatusCodeQuickInfo } from "./autogen/AutogenLayoutDriverEquipStatusCodeQuickInfo";

export class DriverEquipStatusCodeQuickInfo extends AutogenLayoutDriverEquipStatusCodeQuickInfo {
}